var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Essentials/list fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3.75C2.58579 3.75 2.25 4.08579 2.25 4.5C2.25 4.91421 2.58579 5.25 3 5.25H3.00075C3.41496 5.25 3.75075 4.91421 3.75075 4.5C3.75075 4.08579 3.41496 3.75 3.00075 3.75H3Z",
    fill: "#026735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 8.25C2.58579 8.25 2.25 8.58579 2.25 9C2.25 9.41421 2.58579 9.75 3 9.75H3.00075C3.41496 9.75 3.75075 9.41421 3.75075 9C3.75075 8.58579 3.41496 8.25 3.00075 8.25H3Z",
    fill: "#026735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12.75C2.58579 12.75 2.25 13.0858 2.25 13.5C2.25 13.9142 2.58579 14.25 3 14.25H3.00075C3.41496 14.25 3.75075 13.9142 3.75075 13.5C3.75075 13.0858 3.41496 12.75 3.00075 12.75H3Z",
    fill: "#026735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3.75C5.58579 3.75 5.25 4.08579 5.25 4.5C5.25 4.91421 5.58579 5.25 6 5.25H15C15.4142 5.25 15.75 4.91421 15.75 4.5C15.75 4.08579 15.4142 3.75 15 3.75H6Z",
    fill: "#026735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8.25C5.58579 8.25 5.25 8.58579 5.25 9C5.25 9.41421 5.58579 9.75 6 9.75H15C15.4142 9.75 15.75 9.41421 15.75 9C15.75 8.58579 15.4142 8.25 15 8.25H6Z",
    fill: "#026735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12.75C5.58579 12.75 5.25 13.0858 5.25 13.5C5.25 13.9142 5.58579 14.25 6 14.25H15C15.4142 14.25 15.75 13.9142 15.75 13.5C15.75 13.0858 15.4142 12.75 15 12.75H6Z",
    fill: "#026735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3.75C2.58579 3.75 2.25 4.08579 2.25 4.5C2.25 4.91421 2.58579 5.25 3 5.25H3.00075C3.41496 5.25 3.75075 4.91421 3.75075 4.5C3.75075 4.08579 3.41496 3.75 3.00075 3.75H3Z",
    stroke: "#026735",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 8.25C2.58579 8.25 2.25 8.58579 2.25 9C2.25 9.41421 2.58579 9.75 3 9.75H3.00075C3.41496 9.75 3.75075 9.41421 3.75075 9C3.75075 8.58579 3.41496 8.25 3.00075 8.25H3Z",
    stroke: "#026735",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12.75C2.58579 12.75 2.25 13.0858 2.25 13.5C2.25 13.9142 2.58579 14.25 3 14.25H3.00075C3.41496 14.25 3.75075 13.9142 3.75075 13.5C3.75075 13.0858 3.41496 12.75 3.00075 12.75H3Z",
    stroke: "#026735",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3.75C5.58579 3.75 5.25 4.08579 5.25 4.5C5.25 4.91421 5.58579 5.25 6 5.25H15C15.4142 5.25 15.75 4.91421 15.75 4.5C15.75 4.08579 15.4142 3.75 15 3.75H6Z",
    stroke: "#026735",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8.25C5.58579 8.25 5.25 8.58579 5.25 9C5.25 9.41421 5.58579 9.75 6 9.75H15C15.4142 9.75 15.75 9.41421 15.75 9C15.75 8.58579 15.4142 8.25 15 8.25H6Z",
    stroke: "#026735",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12.75C5.58579 12.75 5.25 13.0858 5.25 13.5C5.25 13.9142 5.58579 14.25 6 14.25H15C15.4142 14.25 15.75 13.9142 15.75 13.5C15.75 13.0858 15.4142 12.75 15 12.75H6Z",
    stroke: "#026735",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListfill);
export default __webpack_public_path__ + "static/media/list fill.afb0079ba5eed0edbabe03377ade9141.svg";
export { ForwardRef as ReactComponent };